import mapResponseToEndPrice from './mappers/mapResponseToEndPrice'
/* eslint-disable @typescript-eslint/camelcase */
export default function fetchEndPrice(api: GlobalFetch) {
  return async function(
    roomId,
    dateFrom,
    dateTo,
    persons,
    kids,
    kidsAge,
    service,
    service_persons,
  ) {
    const buildUrl = `/api/v2/reservation/price/id_room/${roomId}/date_from/${dateFrom}/date_to/${dateTo}/persons/${persons}/kids/${kids}/kids_age/${kidsAge}/service/${service}/service_persons/${service_persons}/`
    const response = await api.fetch(buildUrl)
    if (response.ok) {
      const responseBody: IData = await response.json()
      return mapResponseToEndPrice(responseBody)
    } else {
      throw new Error(response.status.toString())
    }
  }
}

export interface IData {
  messages: string[]
  items: IItemData[]
}

interface IItemData {
  price: string
  local_tax: string
  local_tax_included: string
  provision: string
}
